import type { DailyPnlDto } from "@/api/types";
interface PnlHistoryChartProps {
  history: DailyPnlDto[];
}
export default function PnlHistoryChart({ history }: PnlHistoryChartProps) {
  if (history.length === 0) {
    return (
      <div className="flex h-32 items-center justify-center font-mono text-xs text-ink-faint">
        No daily PnL recorded yet.
      </div>
    );
  }
  const maxAbs = Math.max(1, ...history.map((day) => Math.abs(day.realizedPnlUsd)));
  return (
    <div className="flex h-32 items-end gap-1.5">
      {history.map((day) => {
        const heightPercent = Math.max(4, (Math.abs(day.realizedPnlUsd) / maxAbs) * 100);
        const isProfit = day.realizedPnlUsd >= 0;
        return (
          <div key={day.date} className="group relative flex flex-1 flex-col items-center justify-end gap-1">
            <div className="pointer-events-none absolute -top-9 z-10 hidden whitespace-nowrap rounded border border-line bg-raised px-2 py-1 font-mono text-[10px] text-ink group-hover:block">
              {day.date} · {isProfit ? "+" : ""}
              {day.realizedPnlUsd.toFixed(2)} ({day.tradesCount} trades)
            </div>
            <div
              className={`w-full rounded-t ${day.killSwitchTriggered ? "bg-sell" : isProfit ? "bg-profit/70" : "bg-sell/70"}`}
              style={{ height: `${heightPercent}%` }}
            />
            <span className="font-mono text-[9px] text-ink-faint">{day.date.slice(5)}</span>
          </div>
        );
      })}
    </div>
  );
}
